import React, { useState } from "react";
import "../styles/hero.css";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

const Hero = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/car-search?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <section
      className="hero-container"
      itemScope
      itemType="https://schema.org/WebPage"
    >
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-subtitle">Kenya's Trusted Car Dealer</p>
          <h1 className="hero-title" itemProp="headline">
            Find Your Perfect <span>Car in Mombasa</span> Today
          </h1>
          <p className="hero-description" itemProp="description">
            Classic Motors KE offers the best selection of new, foreign used,
            and locally used cars in Kenya. With our 100% delivery record and
            import services, we make car ownership affordable and hassle-free.
            Visit our showroom or browse online to discover your dream vehicle.
          </p>
          <div className="hero-cta">
            <Link to="/cars" className="hero-button" itemProp="potentialAction">
              Browse Our Inventory
            </Link>
            {/* <Link
              to="/contact"
              className="hero-button secondary"
              aria-label="Call us at 0707308556"
            >
              <FaHeadphonesAlt style={{ marginRight: "3px" }} /> 0707308556
            </Link> */}
          </div>

          {/* Structured data for local business */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "AutoDealer",
                "name": "Classic Motors KE",
                "image": "%PUBLIC_URL%/showroom.jpg",
                "@id": "https://www.classicmotorske.com",
                "url": "https://www.classicmotorske.com",
                "telephone": "+254707308556",
                "priceRange": "$$$",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Mombasa",
                  "addressRegion": "Mombasa",
                  "addressCountry": "Kenya"
                },
                "openingHoursSpecification": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                  ],
                  "opens": "08:00",
                  "closes": "17:00"
                }
              }
            `}
          </script>
        </div>

        <div className="hero-search-container">
          <div
            className="search-card"
            role="search"
            aria-label="Car search form"
          >
            <h2 className="search-title">Find Your Dream Car in Kenya</h2>
            <div className="search-input-group">
              <input
                type="text"
                placeholder="Search Toyota, Subaru, Mercedes..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                className="search-input"
                aria-label="Search for cars by make, model or feature"
              />
              <button
                className="search-button"
                onClick={handleSearch}
                aria-label="Search cars"
              >
                <FiSearch size={20} aria-hidden="true" />
              </button>
            </div>
            <div className="popular-searches">
              <span>Popular: </span>
              <Link to="/cars?make=Toyota">Toyota</Link>
              <Link to="/cars?make=Subaru">Subaru</Link>
              <Link to="/cars?type=SUV">SUVs</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
